import React, { useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { configData } from '../config/systemconfigurationconstants';
import * as AWS from 'aws-sdk';
import { useEncryption } from '../customHooks/useEncryption';
const Logout = () => {
    const { encrypt, decrypt } = useEncryption();
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return decodeURIComponent(parts.pop().split(';').shift());
        }
        return null;
    };
    const navigate = useNavigate();
    const { setUser } = useAuth();

    useEffect(() => {
        const performLogout = async () => {
            try {
                logout();
                await Auth.signOut({ global: true });
                setUser(null);

                // Clear any local storage or session data
                // localStorage.clear();
                // sessionStorage.clear();
                indexedDB.databases().then((databases) => {
                    databases.forEach((db) => indexedDB.deleteDatabase(db.name));
                });
                // Redirect to home page
                // navigate('/', { replace: true });
            } catch (error) {
                logout();

                indexedDB.databases().then((databases) => {
                    databases.forEach((db) => indexedDB.deleteDatabase(db.name));
                });
                console.error('Logout error:', error);
                // Still redirect to home on error
                // navigate('/', { replace: true });
            }
        };

        performLogout();
    }, [navigate, setUser]);
    const logout = async () => {

        // setDotLoader(false);
        const lambda = new AWS.Lambda({
            region: configData.LAMBDA_REGION,
            accessKeyId: decrypt(getCookie('ak')),
            secretAccessKey: decrypt(getCookie('sk'))
        });

        const payloadData = {
            Command: configData.LOGOUT_USER,
            SecurityId: "",
            SecurityToken: localStorage.getItem("SecurityToken"),
            EventContextId: "",
            CallerSourceId: "",
            CallerSourceName: ""
        };

        const params = {
            FunctionName: configData.LAMBDA_FUNCTION_NAME1,
            Payload: JSON.stringify(payloadData)
        };

        try {
            // Wrap lambda.invoke in a Promise to use await
            const lambdaResponse = await new Promise((resolve, reject) => {
                lambda.invoke(params, (err, data) => {
                    if (err) reject(err);
                    else resolve(data);
                });
            });

            const parsedPayload = JSON.parse(lambdaResponse.Payload.toString());
            if (parsedPayload.statusCode === 200) {
                // Clear any local storage or session data
                localStorage.clear();
                sessionStorage.clear();
                const parsedBody = JSON.parse(parsedPayload.body);
                navigate('/', { replace: true });

                // setTimeout(() => {
                //     setDotLoader(true);
                // }, 1000);

            }
            else {
                // setDotLoader(false);
            }
        } catch (error) {
            // setDotLoader(false);
            console.error('Error in getCurrentRpm:', error);
        }

    }
    return (
        <div className="logout-container">
            <div className="loading-spinner"></div>
            <p>Logging out...</p>
        </div>
    );
};

export default Logout;
